(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["voco-journey-events"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('voco-journey-events')) {
    customElements.define('voco-journey-events', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enabled !== 'true' || window.Shopify?.designMode || window.Shopify?.theme?.role !== 'main') return;
        this.findersStarted = new WeakSet();
        this.abort = new AbortController();
        const options = { capture: true, signal: this.abort.signal };
        document.addEventListener('click', event => this.onClick(event), options);
        document.addEventListener('voco:variant-selected', event => {
          if (!/^\d+$/.test(String(event.detail?.productId))) return;
          this.send('voco_variant_select', {
            item_id: String(event.detail.productId),
            variant_id: /^\d+$/.test(String(event.detail.variantId)) ? String(event.detail.variantId) : 'unavailable_combination'
          });
        }, { signal: this.abort.signal });
        if (!window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function') {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
        }
      }
      disconnectedCallback() { this.abort?.abort(); }
      send(name, details) {
        try {
          if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true || typeof window.gtag !== 'function') return false;
          window.gtag('event', name, {
            send_to: 'G-PTZXQNPX98',
            page_type: this.dataset.pageType,
            event_source: 'voco_theme_v1',
            ...details
          });
          return true;
        } catch (_) { return false; }
      }
      finderValues(panel) {
        const selected = (attr, allowed, fallback) => {
          const value = panel.querySelector('[' + attr + '][aria-pressed="true"]')?.getAttribute(attr);
          return allowed.includes(value) ? (value || fallback) : fallback;
        };
        return {
          room: selected('data-room', ['living-room-furniture','bedroom-furniture','dining-kitchen-furniture','home-office-furniture'], 'not_selected'),
          budget: selected('data-budget', ['', 'under-300', '300-700', 'over-700'], 'any'),
          priority: selected('data-priority', ['', 'small space', 'storage', 'sleeper convertible', 'easy assembly'], 'any')
        };
      }
      onClick(event) {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        const choice = target.closest('[data-voco-room-finder] .voco-choice');
        const cta = target.closest('[data-voco-room-finder] .voco-finder-cta');
        if (choice || cta) {
          const panel = (choice || cta).closest('[data-voco-room-finder]');
          if (!this.findersStarted.has(panel) && this.send('voco_finder_start', {})) this.findersStarted.add(panel);
          if (cta) this.send('voco_finder_results_click', this.finderValues(panel));
          return;
        }
        const wishlist = target.closest('[data-wishlist]');
        if (wishlist) {
          const id = wishlist.getAttribute('data-product-id');
          this.send('voco_wishlist_click', {
            action_intent: wishlist.classList.contains('wishlist-added') ? 'remove' : 'save',
            ...(/^\d+$/.test(id || '') ? { item_id: id } : {})
          });
          return;
        }
        if (target.closest('.voco-confidence-support')) {
          this.send('voco_support_click', { placement: 'product_trust' });
          return;
        }
        const link = target.closest('a[href]');
        if (!link) return;
        let url;
        try { url = new URL(link.href, window.location.origin); } catch (_) { return; }
        if (url.origin !== window.location.origin) return;
        const collection = url.pathname.match(/\/collections\/([a-z0-9-]+)\/?$/);
        if (collection) {
          this.send('voco_collection_click', { collection_handle: collection[1] });
        } else if (/\/policies\/(shipping-policy|refund-policy)\/?$/.test(url.pathname)) {
          this.send('voco_policy_click', { policy: url.pathname.includes('shipping-policy') ? 'shipping' : 'returns' });
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["voco-variant-status"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('voco-variant-status')) {
    customElements.define('voco-variant-status', class extends HTMLElement {
      connectedCallback() {
        try {
          this.statusData = JSON.parse(this.querySelector('[data-voco-variant-status-data]').textContent);
        } catch (_) { return; }
        this.onVariantSelected = (event) => {
          if (String(event.detail?.productId) !== this.dataset.productId) return;
          this.dataset.variantId = String(event.detail.variantId);
          const status = this.statusData.variants[String(event.detail.variantId)];
          this.querySelector('[data-voco-status-title]').textContent = status?.title || (event.detail.variantId ? this.statusData.checkTitle : this.statusData.unavailable);
          this.querySelector('[data-voco-status-note]').textContent = status?.note || (event.detail.variantId ? this.statusData.checkNote : this.statusData.chooseOther);
        };
        this.onStatusReady = (event) => {
          if (String(event.detail?.productId) !== this.dataset.productId || String(event.detail.variantId) !== this.dataset.variantId) return;
          if (event.detail.title && event.detail.note) {
            this.querySelector('[data-voco-status-title]').textContent = event.detail.title;
            this.querySelector('[data-voco-status-note]').textContent = event.detail.note;
          }
        };
        document.addEventListener('voco:variant-selected', this.onVariantSelected);
        document.addEventListener('voco:variant-status-ready', this.onStatusReady);
      }
      disconnectedCallback() {
        document.removeEventListener('voco:variant-selected', this.onVariantSelected);
        document.removeEventListener('voco:variant-status-ready', this.onStatusReady);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
